module.exports = __webpack_public_path__ + "img/turbo_off.8a023556.png";